export enum AlertType {
  Alerts = 'Alerts',
  Incidents = 'Incidents',
}
export enum AlertsListItemField {
  Number = 'number',
  MetricName = 'metricName',
  Severity = 'severity',
  State = 'state',
  AssignedTo = 'assignedTo',
  CreatedDateTime = 'createdDateTime',
  UpdatedDateTime = 'updatedDateTime',
  StatusCode = 'statusCode',
  ErrorMessage = 'errorMessage',
  Url = 'url',
}
export enum IncidentListItemField {
  Number = 'number',
  ShortDescription = 'shortDescription',
  Priority = 'priority',
  State = 'state',
  AssignedTo = 'assignedTo',
  CreatedDateTime = 'createdDateTime',
  UpdatedDateTime = 'updatedDateTime',
  StatusCode = 'statusCode',
  ErrorMessage = 'errorMessage',
  Url = 'url',
}

export type alertItem = {
  id: string;
  number?: string;
  metricName?: string;
  severity?: string;
  state?: string;
  assignedTo?: string;
  createdDateTime?: string;
  updatedDateTime?: string;
  statusCode?: number;
  errorMessage?: string;
  url?: string;
};

export type incidentItem = {
  id: string;
  number?: string;
  shortDescription?: string;
  priority?: string;
  state?: string;
  assignedTo?: string;
  createdDateTime?: string;
  updatedDateTime?: string;
  statusCode?: number;
  errorMessage?: string;
  url?: string;
};

export type alertsListItem = {
  oServiceNowAlertsResponse: alertItem[];
  oServiceNowIncidentsResponse: incidentItem[];
};

export enum AlertSeverity {
  Critical = 'Critical',
  Minor = 'Minor',
}

export enum ALERT_STATE {
  Open = 'open',
  Reopen = 'reopen',
  Flapping = 'flapping',
}
